export default __webpack_public_path__ + "static/media/graphs.000b7e9e.jpg";